module.exports = __webpack_public_path__ + "img/Carrusel.0806de3e.svg";